const MS_PER_SECOND = 1000;
const DEFAULT_BUSY_RETRY_AFTER_SECONDS = 30;
const MAX_BUSY_RETRY_AFTER_SECONDS = 300;

/**
 * How long to leave a thread alone after another run turned a request away with 429: the server's
 * Retry-After, capped, or a fallback that doubles with every busy answer in a row when it sent none.
 */
export const busyRetryDelayMs = (retryAfterSeconds: number | null, busyStreak: number): number => {
    const fallbackSeconds = DEFAULT_BUSY_RETRY_AFTER_SECONDS * 2 ** Math.max(busyStreak - 1, 0);
    const seconds = Math.min(Math.max(retryAfterSeconds ?? fallbackSeconds, 1), MAX_BUSY_RETRY_AFTER_SECONDS);
    return seconds * MS_PER_SECOND;
};

/** The Retry-After seconds of a response, or null when it carries none or a date. */
export const parseRetryAfterSeconds = (header: string | null): number | null => {
    const value = header?.trim() ?? '';
    return /^\d+$/.test(value) ? Number(value) : null;
};
